import clsx from "clsx";
import {
  ButtonHTMLAttributes,
  AnchorHTMLAttributes,
  FunctionComponent,
  ReactNode,
} from "react";

import { SELECTORS } from "@ui/config";

import * as styles from "./Button.css";

export type ButtonProps = {
  text: string;
  displayType?: keyof typeof styles.container;
  className?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  fullWidth?: boolean;
  active?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

const Button: FunctionComponent<ButtonProps> = ({
  text,
  displayType = "primary",
  className,
  iconLeft,
  iconRight,
  fullWidth,
  active = false,
  ...props
}) => {
  const Component = "href" in props ? "a" : "button";
  return (
    <Component
      className={clsx(
        SELECTORS.Button,
        styles.container[displayType],
        active && styles.active[displayType],
        className && className,
        fullWidth && styles.fullWidth,
      )}
      {...props}
    >
      {iconLeft && <span>{iconLeft}</span>}
      <span>{text}</span>
      {iconRight && <span>{iconRight}</span>}
    </Component>
  );
};

export default Button;
